module.exports = __webpack_public_path__ + "static/media/Ledgerfire.4755fb84.mp4";